import { getRem } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const ToastActions = ({ withMultipleActions, ...other }) => (
  <StyledToastActions $withMultipleActions={withMultipleActions} {...other} />
);

const StyledToastActions = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  margin-left: auto;
  min-width: ${getRem('100px')};
  padding-right: ${({ theme }) => theme.size.spacing.medium.value};
  touch-action: none;
  ${({ $withMultipleActions = false }) =>
    $withMultipleActions &&
    css`
      width: 100%;
    `}
`;

ToastActions.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,
  /** If true sets the width to 100% */
  withMultipleActions: PropTypes.bool,
};

export { ToastActions };
